'use client';

import { usePageVisitClearing } from '@/hooks/use-page-visit-clearing/use-page-visit-clearing';

/** Mount next to locale sync so legacy cookies are cleared before the cookie is re-written. */
export const PageVisitClearing = () => {
  usePageVisitClearing();
  return null;
};
